var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inquiries-list',{attrs:{"type":"all","owner":_vm.owner}})}
var staticRenderFns = []

export { render, staticRenderFns }